import { Modal } from '@affine/component/ui/modal';
import {
  TelemetryConsentPrompt,
  useTelemetryConsentController,
  useTelemetryDisclosureCopy,
} from '@affine/core/components/telemetry-consent';
import { useLiveData, useService } from '@toeverything/infra';
import { useCallback, useEffect } from 'react';

import { FirstCreatedDocTelemetryPromptService } from '../services/first-created-doc-telemetry-prompt';
import * as styles from './welcome-screen.css';

export const FirstCreatedDocTelemetryPrompt = () => {
  const promptService = useService(FirstCreatedDocTelemetryPromptService);
  const requested = useLiveData(promptService.requested$);
  const disclosureCopy = useTelemetryDisclosureCopy();
  const { value: telemetryConsent, setCrashDiagnostics } =
    useTelemetryConsentController();

  useEffect(() => {
    if (requested && telemetryConsent.crashDiagnostics !== 'uninitialized') {
      promptService.dismiss();
    }
  }, [promptService, requested, telemetryConsent.crashDiagnostics]);

  const handleDecision = useCallback(
    (granted: boolean) => {
      setCrashDiagnostics(granted);
      promptService.dismiss();
    },
    [promptService, setCrashDiagnostics]
  );

  if (!requested || telemetryConsent.crashDiagnostics !== 'uninitialized') {
    return null;
  }

  return (
    <Modal
      animation="none"
      closeButtonOptions={{
        'aria-label': disclosureCopy.close,
        className: styles.modalCloseButton,
        'data-testid': 'diagnostics-consent-close',
      }}
      contentOptions={{ className: styles.modalContent }}
      description={disclosureCopy.promptDescription}
      descriptionClassName={styles.modalDescription}
      headerClassName={styles.modalHeader}
      onOpenChange={nextOpen => {
        if (!nextOpen) handleDecision(false);
      }}
      open
      title={disclosureCopy.promptTitle}
      width={520}
    >
      <TelemetryConsentPrompt
        copy={disclosureCopy}
        onDecision={handleDecision}
      />
    </Modal>
  );
};
